import Vue from 'vue'
// import JSON5 from 'json5'
import { createPinia, PiniaVuePlugin } from 'pinia'

Vue.use(PiniaVuePlugin)

export default createPinia()
//   .use(createPersistedState({
//   serializer: {
//     deserialize: JSON5.parse,
//     serialize: JSON5.stringify
//   }
// }))